"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
const table_style_1 = require("./table.style");
(0, theme_1.addStyles)(table_style_1.Style);
exports.Table = {
    view(title, header, rows) {
        const headerChildren = [];
        for (const colHeader of header) {
            headerChildren.push((0, mithril_1.m)('th', { className: table_style_1.CSS.MDL.cell }, colHeader));
        }
        const bodyChildren = [];
        for (const row of rows) {
            const rowChildren = [];
            for (const col of row) {
                rowChildren.push((0, mithril_1.m)('td', { className: `${table_style_1.CSS.cell} ${table_style_1.CSS.MDL.cell}` }, col));
            }
            bodyChildren.push((0, mithril_1.m)('tr', { className: table_style_1.CSS.row }, rowChildren));
        }
        return (0, mithril_1.m)('div', { className: table_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: table_style_1.CSS.title }, typeof title === 'string' ? (0, mithril_1.m)('h6', title) : title),
            (0, mithril_1.m)('table', { className: `${table_style_1.CSS.body} ${table_style_1.CSS.MDL.table}` }, [
                (0, mithril_1.m)('thead', { className: table_style_1.CSS.header }, headerChildren),
                (0, mithril_1.m)('tbody', bodyChildren),
            ]),
        ]);
    },
};
//# sourceMappingURL=table.js.map